import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setConfirmExitMarkup } from "../../reducers/markup-reducer";
import useLanguageChange from "../../hooks/useLanguageChange";
import { GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";
import markupService from "../../services/MarkupService/markupService";
import arMarkupService from "../../services/MarkupService/arMarkupService";
import { isSilentObserverAvailable } from "../../shared/function";

const ExitButton = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { savebtndisabled } = useSelector((state) => state.markup);

    const exitMarkup = () => {
        if (GLOBAL_MEETING_DATA.isAgent) {
            if (arMarkupService.checkARMarkupIsOngoing() || savebtndisabled) {
                markupService.toggleannotationdiv(false, false, true);
            } else {
                // markup -if agent tan ask for modal
                dispatch(setConfirmExitMarkup(true));
            }
        } else if (!GLOBAL_MEETING_DATA.isAgent && !isSilentObserverAvailable()) {
            // markup - guest
            markupService.toggleannotationdiv(false, false, true);
        }
    };

    return (
        <div className='markup-menu-item mob-markup-menu-item markup-menu-exit'>
            <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                <button className='btn markup-menu-btn' onClick={exitMarkup}>
                    <span className='btn-icon icon-close'></span>
                    <span className='mob-btn-text'>{localisedValues?.exit}</span>
                </button>
                <div className='custom-tooltip-content text-nowrap'>
                    <div className='custom-tooltip-in'>
                        <p>{localisedValues?.exit}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExitButton;
